import { atom, selector } from "recoil";
import { recoilPersist } from "recoil-persist";

const { persistAtom } = recoilPersist();

export const accountName = atom({
	key: "accountName",
	default: "",
	effects_UNSTABLE: [persistAtom],
});

export const repoList = atom({
	key: "repoList",
	default: [],
	effects_UNSTABLE: [persistAtom],
});

export const searchRepoList = atom({
	key: "searchRepoList",
	default: [],
	effects_UNSTABLE: [persistAtom],
});

export const toastMessage = atom({
	key: "toastMessage",
	default: "",
	effects_UNSTABLE: [persistAtom],
});

export const bookmarkList = atom({
	key: "bookmarkList",
	default: [],
	effects_UNSTABLE: [persistAtom],
});
